import { CandidatesConst } from '@axiom/const';
import type { Candidate } from '@axiom/validation';

export const FeatureVisibilityUtil = {
  shouldSeeLimitedFeatureSetBasedOnProfileStatus(candidate: Candidate) {
    return [
      CandidatesConst.ProfileStatuses.NewLead,
      CandidatesConst.ProfileStatuses.Certifying,
      CandidatesConst.ProfileStatuses.Reservoir,
    ].includes(candidate.profileStatus);
  },
};
